import { CheckCircle2 } from "lucide-react";
import { formatDate, EMPTY_BOX } from "./format";
import { ExportButton } from "./ExportButton";

const RequestCard = ({ r, i, onResolve }) => (
  <article data-testid={`admin-maintenance-card-${i}`} className="rounded-3xl border border-navy/10 bg-white p-6">
    <div className="flex items-start justify-between gap-3">
      <div>
        <p className="font-display text-base font-bold text-navy">{r.name}</p>
        <a href={`mailto:${r.email}`} className="text-sm text-slate-600 transition-colors hover:text-gold-dark">{r.email}</a>
      </div>
      <span
        className={`rounded-full px-3 py-1 text-[11px] font-semibold ${r.status === "traitee" ? "bg-navy/5 text-slate-500" : "bg-gold/15 text-gold-dark"}`}
        data-testid={`admin-maintenance-status-${i}`}
      >
        {r.status === "traitee" ? "Traitée" : "Nouvelle"}
      </span>
    </div>
    <p className="mt-4 border-t border-navy/10 pt-4 text-sm leading-relaxed text-slate-600">{r.message}</p>
    <p className="mt-3 font-mono text-[10px] text-slate-400">{formatDate(r.created_at)}</p>
    {r.status !== "traitee" && (
      <button
        data-testid={`admin-resolve-request-${i}`}
        onClick={() => onResolve(r.id)}
        className="mt-4 flex items-center gap-2 rounded-full bg-navy px-4 py-2 text-xs font-semibold text-white transition-all hover:bg-navy-light"
      >
        <CheckCircle2 size={13} /> Marquer traitée
      </button>
    )}
  </article>
);

export const MaintenanceTab = ({ requests, onResolve }) => (
  <div className="mt-8" data-testid="admin-maintenance">
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
      <h2 className="font-display text-lg font-bold text-navy">Demandes de modification</h2>
      <ExportButton resource="maintenance" filename="maintenance.csv" label="Exporter en CSV" />
    </div>
    {requests.length === 0 ? (
      <p className={`${EMPTY_BOX} py-12`} data-testid="admin-maintenance-empty">
        Aucune demande de modification pour le moment. Celles de vos abonnés maintenance apparaîtront ici.
      </p>
    ) : (
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2" data-testid="admin-maintenance-list">
        {requests.map((r, i) => <RequestCard key={r.id} r={r} i={i} onResolve={onResolve} />)}
      </div>
    )}
  </div>
);
